import { render, staticRenderFns } from "./incremental-award.vue?vue&type=template&id=3806564b&"
import script from "./incremental-award.vue?vue&type=script&lang=js&"
export * from "./incremental-award.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports